import React, { useState } from 'react';
import { userRequest } from '../../utils/requestMethods';
import { useStateContext } from '../../contexts/ContextProvider';

const TermSettings = ({ termNumber, termData, onDateChange }) => {
  const { school, refreshSchool } = useStateContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSave = async () => {
    if (!termData?.start_date || !termData?.end_date) {
      setError("Please fill in both start and end dates.");
      setTimeout(() => setError(""), 5000);
      return;
    }

    setLoading(true);
    try {
      // Check if this term exists in the school settings
      const termExists = school?.settings?.terms?.some(
        t => t.term === termNumber
      );

      if (termExists) {
        // Update existing term
        await userRequest.patch(`/schools/${school._id}/settings/term`, {
          term: {
            term: termNumber,
            start_date: termData.start_date,
            end_date: termData.end_date,
          },
        });
        setSuccess(`Term ${termNumber} details updated successfully.`);
      } else {
        // Create new term
        await userRequest.post(`/schools/${school._id}/settings/term`, {
          term: termNumber,
          start_date: termData.start_date,
          end_date: termData.end_date,
        });
        setSuccess(`Term ${termNumber} details saved successfully.`);
      }
      refreshSchool();
      setTimeout(() => setSuccess(""), 3000);
    } catch (error) {
      console.error(error);
      setError("Failed to save term details. Please try again.");
      setTimeout(() => setError(""), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border rounded-lg p-6">
      {error && (
        <div className="mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
      {success && (
        <div className="mb-4 p-2 bg-green-100 border border-green-400 text-green-700 rounded">
          {success}
        </div>
      )}
      
      <h4 className="text-md font-medium mb-4">Term {termNumber}</h4>
      
      <div className="space-y-4">
        <div>
          <label htmlFor={`term-${termNumber}-start`} className="block mb-2 text-sm text-gray-600">
            Start Date
          </label>
          <input
            type="date"
            id={`term-${termNumber}-start`}
            value={termData?.start_date || ''}
            onChange={(e) => onDateChange(termNumber, 'start_date', e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          />
        </div>
        
        <div>
          <label htmlFor={`term-${termNumber}-end`} className="block mb-2 text-sm text-gray-600">
            End Date
          </label>
          <input
            type="date"
            id={`term-${termNumber}-end`}
            value={termData?.end_date || ''}
            onChange={(e) => onDateChange(termNumber, 'end_date', e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          />
        </div>
      </div>
      
      <button
        onClick={handleSave}
        disabled={loading}
        type="button"
        className={`mt-4 w-full py-2 border border-indigo-500 text-indigo-500 rounded-md hover:bg-indigo-50 transition-colors text-sm font-medium ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
    </div>
  );
};

export default TermSettings;